import React, { useEffect } from 'react';
import { Widget, addResponseMessage } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import './chatwidget.scss';
import logo from './logo.jpg';

function ChatWidget() {
  useEffect(() => {
    addResponseMessage('Welcome to **DevIN** ');
  }, []);

  const handleNewUserMessage = (newMessage) => {
    console.log(`New message incoming! ${newMessage}`);
    // Now send the message throught the backend API
  };

    return (
      <div className="ChatWidgetapp">
        <Widget
          handleNewUserMessage={handleNewUserMessage}
          profileAvatar={logo}
          title="Team Messages"
          subtitle=""
          toggleWidget = {true}
      
        />
      </div>
    );
}

export default ChatWidget;

